import { render } from "./AutoSuggestionsOverview.vue?vue&type=template&id=32a0acec"
import script from "./AutoSuggestionsOverview.vue?vue&type=script&lang=js"
export * from "./AutoSuggestionsOverview.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__